// extracted by mini-css-extract-plugin
module.exports = {"preloader":"CourseCard_preloader__1Xh_H","sp":"CourseCard_sp__S_ow7"};